module.exports = __webpack_public_path__ + "static/media/freshPass.ad37bc7d.svg";